export function registerServiceWorker({
  environment = process.env.NODE_ENV,
  navigatorObject = globalThis.navigator,
  windowObject = globalThis.window,
  documentObject = globalThis.document,
  updateIntervalMs = 5 * 60 * 1000,
} = {}) {
  if (
    environment !== "production"
    || !navigatorObject?.serviceWorker
    || !windowObject?.addEventListener
  ) {
    return false;
  }

  windowObject.addEventListener("load", async () => {
    try {
      const registration = await navigatorObject.serviceWorker.register(
        "/service-worker.js",
        {
          scope: "/",
          updateViaCache: "none",
        },
      );

      let reloadingForNewWorker = false;
      navigatorObject.serviceWorker.addEventListener?.("controllerchange", () => {
        if (reloadingForNewWorker) return;
        reloadingForNewWorker = true;
        windowObject.location?.reload?.();
      });

      const checkForUpdate = () => {
        registration.update().catch(() => {
          // Browser mode remains usable if an update probe fails.
        });
      };

      checkForUpdate();

      windowObject.addEventListener("focus", checkForUpdate);
      documentObject?.addEventListener?.("visibilitychange", () => {
        if (documentObject.visibilityState === "visible") checkForUpdate();
      });

      if (typeof windowObject.setInterval === "function" && updateIntervalMs > 0) {
        windowObject.setInterval(checkForUpdate, updateIntervalMs);
      }
    } catch {
      // Installation support is progressive enhancement; browser mode remains usable.
    }
  }, { once: true });

  return true;
}
